export default "__VITE_ASSET__BPnBoaUm__"